"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfSampleInsertDTO = instanceOfSampleInsertDTO;
exports.SampleInsertDTOFromJSON = SampleInsertDTOFromJSON;
exports.SampleInsertDTOFromJSONTyped = SampleInsertDTOFromJSONTyped;
exports.SampleInsertDTOToJSON = SampleInsertDTOToJSON;
exports.SampleInsertDTOToJSONTyped = SampleInsertDTOToJSONTyped;
/**
 * Check if a given object implements the SampleInsertDTO interface.
 */
function instanceOfSampleInsertDTO(value) {
    if (!('account' in value) || value['account'] === undefined)
        return false;
    if (!('password' in value) || value['password'] === undefined)
        return false;
    return true;
}
function SampleInsertDTOFromJSON(json) {
    return SampleInsertDTOFromJSONTyped(json, false);
}
function SampleInsertDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'uNo': json['uNo'] == null ? undefined : json['uNo'],
        'account': json['account'],
        'password': json['password'],
    };
}
function SampleInsertDTOToJSON(json) {
    return SampleInsertDTOToJSONTyped(json, false);
}
function SampleInsertDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'uNo': value['uNo'],
        'account': value['account'],
        'password': value['password'],
    };
}
